import { cn } from "@/lib/utils";
import { Waves, Dumbbell, Utensils, Mountain, Palette } from "lucide-react";

const categories = [
  { name: "All Vibes", icon: null },
  { name: "Surfing", icon: Waves },
  { name: "Yoga", icon: Dumbbell },
  { name: "Culinary", icon: Utensils },
  { name: "Adventure", icon: Mountain },
  { name: "Art", icon: Palette },
];

interface CategoryFiltersProps {
  selected: string;
  onSelect: (category: string) => void;
}

export function CategoryFilters({ selected, onSelect }: CategoryFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => {
        const isActive = selected === category.name;
        const Icon = category.icon;
        
        return (
          <button
            key={category.name}
            onClick={() => onSelect(category.name)}
            className={cn(
              "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors",
              isActive
                ? "bg-chip-active text-chip-active-foreground"
                : "bg-chip-inactive text-chip-inactive-foreground hover:bg-muted"
            )}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {category.name}
          </button>
        );
      })}
    </div>
  );
}
